import {Component, Injector, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {EstudioService} from '../estudio.service';
import {GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import {CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Evento} from '../../../_models/evento';
import {EventoUnidad} from '../../../_models/evento-unidad';


@Component({
  selector: 'meta-list',
  standalone: false,
  templateUrl: 'evento-list.component.html'
})

export class EventoListComponent implements OnInit, AfterViewInit {

  eventos: Evento[] = [];

  categorias: any;
  unidadID: number;
  guardando = false;

  dataSource: MatTableDataSource<Evento>;
  displayedColumns = ['id', 'categoria', 'descripcion'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private estudioService: EstudioService,
              private modalService: GlmModalService,
              private customAlertService: CustomAlertService,
              private injector: Injector,
              private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.categorias = this.injector.get('categorias', []);
    this.unidadID = this.injector.get('idUnidad', []);
    this.eventos = this.injector.get('listaEventos', []);

    this.dataSource = new MatTableDataSource(this.eventos);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'categoria':
          return item.categoria['id'];
        default:
          return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  onSubmit() {
    const requestObject = {idOrigen: +this.unidadID, ids: ''},
      ids = [];
    this.eventos.map((evento, i) => {
      if (evento.isSelected) {
        ids.push(this.eventos[i].id);
      }
    });
    requestObject.ids = ids.toString();
    this.estudioService.importarEventos(requestObject).subscribe(res => {
      const lista = this.estudioService.extractData(res);
      this.snackBar.open(
        `Se ha conectado el evento satisfactoriamente con la unidad.`,
        null,
        {duration: 2250});
      lista.map(evento => {
        this.estudioService.agregarElemento(new EventoUnidad(evento));
      });
      this.modalService.cerrarModal();
    }, err => {
      this.guardando = false;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible importar el evento. <br> Código de error: ${err.statusText}`
      });
    });
  }


  cancelar() {
    this.modalService.cerrarModal();
  }

  checkFiltros(sort) {
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  cambiarEstado(evt, element) {
    element.isSelected = evt.checked;
  }
}
